import { UserService } from './../../../base-services/user.service';
import { DefaultListType } from './../../../base-models/default-list-type';
import { ColumnData } from './../../../base-models/column-data';
import { ModelDataService } from './../../../base-services/model-data.service';
import { ModalService } from './../../../base-services/modal.service';
import { CollectionService } from './../../../base-services/collection.service';
import { BaseDataService } from './../../../base-services/base-data.service';
import { BaseDropdown } from './../base-dropdown';
import { BaseEntity } from './../../../base-models/base-entity';
import { Component, Input, ChangeDetectorRef, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { MakeProvider } from "../../abstract-custom-control";
import { ViewChild, HostListener } from '@angular/core';
import { DefaultTableComponent } from '../../default-table/default-table.component';
import { Subscription } from 'rxjs';
import { log } from '../../../base-services/log.method-decorator';
import { DefaultButtonsConfig } from '../../../base-models/default-buttons-config';
import { UserRightsService } from '../../../base-services/user-rights.service';

@Component({
    selector: 'yt-dropdown-picklist',
    templateUrl: './dropdownpicklist.component.html',
    providers: [MakeProvider(DropdownPicklistComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownPicklistComponent<T extends BaseEntity> extends BaseDropdown<T>{
    constructor(
        protected baseDataService: BaseDataService,
        public collectionService: CollectionService,
        protected modalService: ModalService,
        protected modelDataService: ModelDataService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected userRightsService: UserRightsService
    ){
        super(baseDataService, collectionService, modalService, modelDataService, changeDetectorRef);
    }

    tableConfig: any = {};
    treeviewConfig: any = {};
    showPicklist: boolean = false;
    displayValue: string;
    filter: string;
    dropDownName: number = parseInt((Math.random() * 1000).toString(), 10);
    _tableColumns: ColumnData[];
    allowAddNew: boolean = false;
    allowEdit: boolean = false;

    private itemsLoadedSubscription: Subscription;

    @HostListener('document:click', ['$event'])
    onClick(event){
        let selector: string = 'div[name="dropdown' + this.dropDownName + '"]';
        if(event.target.closest(selector) == null)
            //&& (event.target.name != 'picklistInput' + this.dropDownName
            //&& (event.target.attributes['name'] == null && event.target.attributes['name'].value != 'picklistPlaceholder' + this.dropDownName)))
            this.showPicklist = false;
    }

    //@Input() TableColumns: ColumnData[];
    @Input() Type: DefaultListType = DefaultListType.List;
    @Input() Width: string;
    @Input() Position: string = 'left';
    @Input() FilterByAllColumns: boolean = true;
    @Input() Name: string;
    @Input() Index: string;
    @Input() ShowHeader: boolean = true;
    @Input() ShowFooter: boolean = true;
    @Input() set TableColumns(columns: ColumnData[]){
        this._tableColumns = new ColumnData(this.userService).LoadColumnData(columns);
    }
    @Input() AutoSelect: boolean = false;

    @Output() OnItemSelected = new EventEmitter();
    @Output() GetItems = new EventEmitter();

    @ViewChild('defaultTable', { static: false }) defaultTable: DefaultTableComponent;

    ngOnInit(){
        super.ngOnInit();

        this.allowAddNew = this.AllowAddNew == null ? this.userRightsService.GetUserRightValue(this._modelData.MainList.UserRightsModelName.toLowerCase(), 'add') : this.AllowAddNew;
        this.allowEdit = this.AllowEdit == null ? this.userRightsService.GetUserRightValue(this._modelData.MainList.UserRightsModelName.toLowerCase(), 'edit') : this.AllowEdit

        this.tableConfig = {
            EditIcon: {
                //Visible: this.AllowEdit
                Visible: this.allowEdit,
                Icon: 'fa fa-fw item-icon ' + this._modelData.MainList.EditIcon
            },
            DeleteIcon: {
                Visible: false
            },
            PrintIcon: {
                Visible: false
            },
            DefaultSortKey: this.OrderBy,
            DefaultSortReverse: false,
            ShowIndex: false,
            ShowDefaultListButtons: false,
            Height: '297px',
            ShowCheckBoxes: false,
            ShowSearch: false,
            DefaultListButtonsConfig: new DefaultButtonsConfig(),
            ShowHeader: this.ShowHeader,
            ShowFooter: this.ShowFooter
        }

        this.treeviewConfig = {
            ShowDefaultListButtons: false,
            EditIcon: {
                Visible: false
            },
            DeleteIcon: {
                Visible: false
            }
        }
    }

    ngAfterViewInit(){
        if(this.defaultTable)
            this.defaultTable.FilterByAllColumns = this.FilterByAllColumns;
    }

    SelectItem(item: T){
        if(item != null){
            this.showPicklist = false;
            //this.displayValue = item[this.ModelProperty];
            this.displayValue = this.collectionService.GetPropertiesValues(item, this.ModelProperty);
            this.value = item.ID;
            this.oldValue = this.value;
            this.OnItemSelected.emit(item);
            this.filter = null;
        }
    }

    SelectItemByID(ID: number){
        this.showPicklist = false;
        //this.displayValue = this.Items.find(item => item.ID == ID)[this.ModelProperty];
        this.getItemValue(this.Items, ID);
        this.value = ID;
        this.oldValue = this.value;
    }

    togglePicklist(toggle: boolean = true){
        if(toggle){
            this.showPicklist = !this.showPicklist;
            if(this.showPicklist){
                this.filter = null;
                this.selectControl.nativeElement.focus();
            }
            if(this.defaultTable)
                this.defaultTable.ScrollToView = this.showPicklist;

            if(this.defaultTable && this.showPicklist)
                this.defaultTable.calculateHeight();

            this.changeDetectorRef.markForCheck();
        }
    }

    Clear() {
        // console.log('Clearing component state');
        super.Clear();
        this.displayValue = null;
        this.value = null;
        this.oldValue = null;
        this.OnItemSelected.emit(null);
    }
    
    writeValue(value) {
        //  const now = new Date();
        //  console.log(`enter writeValue ${this.Label} value: ${value} vreme ${now.getMinutes()}:${now.getSeconds()}: ${now.getMilliseconds()}`);
        super.writeValue(value);
        this.getDisplayValue(value);
        if (value && this.Items) {
            if (this.defaultTable) {
                this.defaultTable.SetSelectedItem = this.Items.find(item => item.ID == value);
                //console.log('Set selected item in defaultTable:', this.defaultTable.SetSelectedItem);
            }
            this.OnItemSelected.emit(this.Items.find(item => item.ID == value));
        } else if (this.Items != null && this.Items.count() == 1 && this.AutoSelect && value == null) {
            //console.log('Auto-selecting single item');
            this.SelectItem(this.Items.get(0));
        } else if (value == null && this.defaultTable) {
            //console.log('Clearing selected item in defaultTable');
            this.defaultTable.SetSelectedItem = null;
        }
    
        if (value == null) {
            if (this.hasDefaultValue()) {
                //console.log('Selecting default item');
                this.SelectItem(this.getDefaultItem());
                return;
            }
    
            if (this.Items && this.Items.count() == 1 && this.AutoSelect) {
                //console.log('Auto-selecting only item due to AutoSelect true');
                this.SelectItem(this.Items.get(0));
                return;
            }
        }
    }
    
    //@log()
    private getDisplayValue(ID) {
        //  const now = new Date();
        //  console.log(`enter getDisplayValue ${this.Label} ID: ${ID} vreme ${now.getMinutes()}:${now.getSeconds()}: ${now.getMilliseconds()}`);

        if (ID == null) {
            this.displayValue = '';
            // console.log('No ID provided, displayValue set to empty');
            
        }
    
        if (this.itemsLoadedSubscription) {
            this.itemsLoadedSubscription.unsubscribe();
            // console.log('Unsubscribed from previous itemsLoadedSubscription');
        }
        //  console.log(`before subscription ${this.Label} value: ${ID} vreme ${now.getMinutes()}:${now.getSeconds()}: ${now.getMilliseconds()}`);
        this.itemsLoadedSubscription = this.itemsLoadedObservable.subscribe(() => {
            //  console.log(`enter subscription ${this.Label} value: ${ID} vreme ${now.getMinutes()}:${now.getSeconds()}: ${now.getMilliseconds()}`);
            if (this.Items && ID) {
                 this.getItemValue(this.Items, ID);
                const selectedItem = this.Items.find(item => item.ID == ID);
                if (this.defaultTable && selectedItem) {
                    this.defaultTable.SetSelectedItem = selectedItem;
                    this.OnItemSelected.emit(selectedItem);
                    //  console.log('Updated displayValue and emitted OnItemSelected for ID:', ID);
                }
                this.changeDetectorRef.markForCheck();
            }
            //  console.log(`exit subscription 1 ${this.Label} value: ${ID} vreme ${now.getMinutes()}:${now.getSeconds()}: ${now.getMilliseconds()}`);
        });

        //  console.log(`exit subscription 2 ${this.Label} value: ${ID} vreme ${now.getMinutes()}:${now.getSeconds()}: ${now.getMilliseconds()}`);
    
    }
    

    private getItemValue(items, ID) {
        // console.log('getItemValue called for ID:', ID);
        let value = '';
        items.forEach(item => {
            if (item.ID == ID) {
                value = this.collectionService.GetPropertiesValues(item, this.ModelProperty);
                // console.log('Found item with ID:', ID, 'value:', value);
                this.displayValue = value;
                this.changeDetectorRef.markForCheck();
            } else if (item["Items"] != null) {
                // console.log('Checking nested items for ID:', ID);
                this.getItemValue(item["Items"], ID);
            }
        });
    }
    
    onInput(value){
        // console.log('onInput: ' + value + ', displayValue: ' + this.displayValue);
        this.showPicklist = true;
        this.filter = value;
        //super.Clear();
        //this.displayValue = '';
        // console.log('displayValue: ' + this.displayValue);
    }

    onKeypress(event){
        if(event.keyCode == 13 && this.showPicklist)
            event.stopPropagation();
        if(this.showPicklist && this.defaultTable)
            this.defaultTable.KeyCode = event.keyCode;
        if((event.keyCode == 27 || event.keyCode == 9) && this.showPicklist)
            this.showPicklist = false;
        else if(event.keyCode == 27)
            this.Clear();
        if(event.keyCode == 40){
            this.showPicklist = true;
            // this.filter = null;
            // this.selectControl.nativeElement.focus();
            // this.changeDetectorRef.markForCheck();
        }
        //if((event.keyCode == 13 && this.showPicklist))
            //event.stopPropagation();
        //event.preventDefault();
    }

    OnItemAdded(item){
        super.OnItemAdded(item);

        this.Items = this.Items.push(item);
        if(this.defaultTable)
            this.defaultTable.SetSelectedItem = item;
        //this.getDisplayValue(item.ID);
        //this.OnItemSelected.emit(this.Items.find(itemValue => itemValue.ID = item.ID));
        this.SelectItem(item);
        this.changeDetectorRef.markForCheck();
    }

    OnBlur(){
        if(this.value != this.oldValue){
            this.getDisplayValue(this.value);
        }
    }

    itemsLoaded(){
        super.itemsLoaded();

        if(this.Items.count() == 1 && this.AutoSelect && this.value == null){
            this.SelectItem(this.Items.get(0));
        }

        if ((this.value == null) && this.hasDefaultValue()) {
            this.SelectItem(this.getDefaultItem());
        }

        this.GetItems.emit(this.Items);
    }

    OnItemEdited(item){
        super.OnItemEdited(item);

        this.Items = this.Items.set(this.getItemIndex(item.ID), item);
        //this.SelectItem(item);
        this.changeDetectorRef.markForCheck();
        this.getDisplayValue(this.value)
    }

    private getItemIndex(ID: number){
        let itemIndex = -1;
        this.Items.forEach((item, index) => {
            if(item.ID == ID)
            itemIndex = index;
        })
        return itemIndex;
    }

    private hasDefaultValue(){
        if(!this.Items){
            return false;
        }
        
        return this.Items.find(item => item.IsDefault === true) != null;
    }

    private getDefaultItem(){
        return this.Items.find(item => item.IsDefault === true);
    }
}
